import React from 'react';
import "./swipe.css"
import S1 from '../../../assets/swipeleft.png'
import S2 from '../../../assets/swiperight.png'


const Swipe = (props) => {
    return ( <>
    <div className={props.swipe}>
        <img src={S1} alt="Swipe left" />
        <img src={S2} alt="Swipe right" />
    </div>
            </> );
}
 
export default Swipe;